import { useQuery } from '@tanstack/react-query';
import { apiClient, Product, ProductStatus, useAuthStore } from '@dukene/shared';

interface ProductsResponse {
  products: Product[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    pages: number;
  };
}

interface UseProductsOptions {
  search?: string;
  status?: ProductStatus | 'ALL';
  categoryId?: string;
  page?: number;
  limit?: number;
}

export function useProducts(options: UseProductsOptions = {}) {
  const { search, status, categoryId, page = 1, limit = 50 } = options;
  const activeStoreId = useAuthStore((state) => state.activeStoreId);

  return useQuery<ProductsResponse>({
    queryKey: ['merchant-products', activeStoreId, status, categoryId, search, page, limit],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (status && status !== 'ALL') params.append('status', status);
      if (categoryId && categoryId !== 'ALL') params.append('categoryId', categoryId);
      if (search) params.append('search', search);
      params.append('page', page.toString());
      params.append('limit', limit.toString());
      
      return apiClient.get<ProductsResponse>(`/products?${params}`);
    },
    enabled: !!activeStoreId,
  });
}
